import data from '../data/cap'
import colors from '../data/colors'

const cap = {
  namespaced: true,
  state: {
    data,
    colors,
    textures: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
    // '18',
      '19',
      '20',
      '21',
    ],
    selectedArea: {
      id: 1,
      slug: 'visor',
      name: 'バイザー'
    },
    selectedPart: [
      {
        id: 1,
        slug: 'visor_form',
        name: '形',
        area_id: 1,
      },
      {
        id: 3,
        slug: 'crown_front',
        name: '正面',
        area_id: 2,
      },
    ],
    selectedVisorFormItem: {
      id: 1,
      slug: 'visor_form_arch',
      name: 'アーチ',
    },
    selectedVisorFormItemType: null,
    selectedVisorFormItemColor: null,
    selectedVisorFormItemTexture: null,
    selectedVisorLineItem: {
      id: 1,
      slug: 'visor_line_off',
      name: 'なし',
    },
    selectedVisorLineItemColor: null,
    selectedCrownFrontColor: null,
    selectedCrownBackColor: null,
    selectedCrownHoleColor: null,
    selectedCrownButtonColor: null,
    selectedMarkItem: {},
    selectedMarkItemColor1: null,
    selectedMarkItemColor2: null,
    selectedMarkItemColor3: null,
  },
  mutations: {
    // 選択状態の初期化
    clearCap (state) {
      state.selectedArea = {
        id: 1,
        slug: 'visor',
        name: 'バイザー'
      }
      state.selectedPart = [
        {
          id: 1,
          slug: 'visor_form',
          name: '形',
          area_id: 1,
        },
        {
          id: 3,
          slug: 'crown_front',
          name: '正面',
          area_id: 2,
        },
      ]
      state.selectedVisorFormItem = {
        id: 1,
        slug: 'visor_form_arch',
        name: 'アーチ',
      },
      state.selectedVisorFormItemType = null
      state.selectedVisorFormItemColor = null
      state.selectedVisorFormItemTexture = null
      state.selectedVisorLineItem = {
        id: 1,
        slug: 'visor_line_off',
        name: 'なし',
      },
      state.selectedVisorLineItemColor = null
      state.selectedCrownFrontColor = null
      state.selectedCrownBackColor = null
      state.selectedCrownHoleColor = null
      state.selectedCrownButtonColor = null
      state.selectedMarkItem = {}
      state.selectedMarkItemColor1 = null
      state.selectedMarkItemColor2 = null
      state.selectedMarkItemColor3 = null
    },
    // エリアの選択
    changeArea (state, payload) {
      state.selectedArea = payload
    },
    // パーツの変更
    changePart (state, payload) {
      const addPart = state.selectedPart.concat()
      addPart.unshift(payload);
      state.selectedPart = addPart.filter((item, index, self) => {
        return self.findIndex(i => i.area_id === item.area_id) === index
      })
    },
    // エレメントの変更
    changeElement (state, payload) {
      const addElement = state.selectedElement.concat()
      addElement.unshift(payload);
      state.selectedElement = addElement.filter((item, index, self) => {
        return self.findIndex(i => i.part_id === item.part_id) === index
      })
    },
    // バイザー 形の変更
    changeVisorFormItem (state, payload) {
      state.selectedVisorFormItem = payload
    },
    // バイザー 形の色変更
    changeVisorFormItemColor (state, payload) {
      state.selectedVisorFormItemType = 'color'
      state.selectedVisorFormItemColor = payload
      state.selectedVisorFormItemTexture = null
    },
    // バイザー 形のテクスチャ変更
    changeVisorFormItemTexture (state, payload) {
      state.selectedVisorFormItemType = 'texture'
      state.selectedVisorFormItemTexture = payload
      state.selectedVisorFormItemColor = null
    },
    // バイザー ラインの変更
    changeVisorLineItem (state, payload) {
      state.selectedVisorLineItem = payload
    },
    // バイザー ラインの色変更
    changeVisorLineItemColor (state, payload) {
      state.selectedVisorLineItemColor = payload
    },
    // クラウン 正面の色変更
    changeCrownFrontColor (state, payload) {
      state.selectedCrownFrontColor = payload
    },
    // クラウン サイドバックの色変更
    changeCrownBackColor (state, payload) {
      state.selectedCrownBackColor = payload
    },
    // クラウン 穴がかりの色変更
    changeCrownHoleColor (state, payload) {
      state.selectedCrownHoleColor = payload
    },
    // クラウン 天ボタンの色変更
    changeCrownButtonColor (state, payload) {
      state.selectedCrownButtonColor = payload
    },
    // マーク アイテム選択
    changeMarkItem (state, payload) {
      state.selectedMarkItem = payload;
    },
    // マーク アイテム色選択1
    changeMarkItemColor1 (state, payload) {
      state.selectedMarkItemColor1 = payload;
    },
    // マーク アイテム色選択2
    changeMarkItemColor2 (state, payload) {
      state.selectedMarkItemColor2 = payload;
    },
    // マーク アイテム色選択3
    changeMarkItemColor3 (state, payload) {
      state.selectedMarkItemColor3 = payload;
    },
  }
}
export default cap
